import React, {Component} from "react"
import Header from "./header"
import Footer from "./footer"
import Drawer from "../drawer"
import "../../styles/main.scss"

class MainLayout extends Component {
  state = {
    isDrawerOpen: false
  }

  handleOpenDrawer = () => this.setState({isDrawerOpen: true});
  handleCloseDrawer = () => this.setState({ isDrawerOpen: false });
  
  render() {
    
    return (
      <div className="Layout-wrapper">
        <Header handleOpenDrawer={this.handleOpenDrawer} />
        {this.props.children}
        <Footer />
        <Drawer open={this.state.isDrawerOpen} handleCloseDrawer={this.handleCloseDrawer} />
      </div>
    )
  }
}

export default MainLayout
